module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACYSURBVHgB7dSxDcIwEIXhd5aJIDRhgjBKRmEDyAZsgOgyBkgUlIwAG3gJJAsSP44OKR12F3/lFb90zZNmx6p8YStEg1gC9yzQ2qXHAcINUiBQeqyM1tdISERqg8TI4WhH14GtmHDHHyx6d+oWbhT9Bi/d7IYIyd/P0RzN0QlHyfD4PfQ6X4hki7nZv32odLJrndjzVfcQkT4ryio1HOUnlAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qr-code-1.png
// module id = LoJa
// module chunks = 1